// module scope: the home page unmounts while a catalog is open, the positions have to outlive it
const positions = new Map<string, number>();
const folderHrefs = new Set<string>();
let pendingReveal: { href: string; selector: string } | null = null;
let workspace: string | undefined;

export type HomeScreen = "home" | "folder";

export const saveHomeScroll = (href: string, top: number) => {
	positions.set(href, top);
};

export const requestHomeReveal = (href: string, selector: string) => {
	pendingReveal = { href, selector };
};

export const enterHomeScrollWorkspace = (path: string | undefined) => {
	if (path === workspace) return;
	workspace = path;
	positions.clear();
	folderHrefs.clear();
	pendingReveal = null;
};

const forgetFolderScrolls = () => {
	for (const href of folderHrefs) positions.delete(href);
	folderHrefs.clear();
};

const centeredTop = (container: HTMLElement, selector: string) => {
	const target = container.querySelector(selector);
	if (!target) return 0;

	const containerRect = container.getBoundingClientRect();
	const targetRect = target.getBoundingClientRect();
	const { scrollTop } = container;

	const targetCenter = targetRect.top + targetRect.height / 2 - containerRect.top;
	return Math.max(0, scrollTop + targetCenter - containerRect.height / 2);
};

export const applyHomeScroll = (
	container: HTMLElement,
	workspacePath: string | undefined,
	href: string,
	screen: HomeScreen,
) => {
	enterHomeScrollWorkspace(workspacePath);
	// a folder reopened from home starts at the top, but going back to it from a catalog finds it where it was left
	if (screen === "home") forgetFolderScrolls();
	else folderHrefs.add(href);

	const reveal = pendingReveal?.href === href ? pendingReveal : null;
	pendingReveal = null;

	const top = positions.get(href) ?? (reveal ? centeredTop(container, reveal.selector) : 0);
	container.scrollTop = top;
	positions.set(href, top);
};
